import { render } from "./FormCheckbox.vue?vue&type=template&id=4c204d3a&scoped=true&lang=pug&bindings={\"label\":\"props\",\"name\":\"props\",\"required\":\"props\",\"id\":\"props\",\"checked\":\"props\",\"value\":\"setup\",\"className\":\"setup\",\"error\":\"setup\"}"
import script from "./FormCheckbox.vue?vue&type=script&lang=js"
export * from "./FormCheckbox.vue?vue&type=script&lang=js"

import "./FormCheckbox.vue?vue&type=style&index=0&id=4c204d3a&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-4c204d3a"

export default script